import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';

function EditStartDateModal({ program, onClose, onSave }) {
  const [startDate, setStartDate] = useState(program.program_start_date);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    setError(null);
    setIsSaving(true);

    try {
      await workoutAPI.updateProgramStartDate(program.id, startDate);
      onSave(); // Trigger refresh
      onClose();
    } catch (err) {
      console.error('Error updating start date:', err);
      setError('Failed to update start date. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Start Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="mb-3">
          <strong>Program:</strong> {program.program_name}
        </p>

        <Alert variant="warning" className="mb-3">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Changing the start date will recalculate all future workout dates and reset any schedule shifts.
        </Alert>

        <Form.Group>
          <Form.Label>Start Date (Day 1)</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={isSaving}
          />
          <Form.Text className="text-muted">
            All workout dates will be calculated from this date.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={isSaving || !startDate}>
          {isSaving ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Saving...
            </>
          ) : (
            'Save Changes'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditStartDateModal;
